<template>
  <div
      class="PROCARD-HEADERNEW"
      :class="{
        'SELECTED': isSelected,
        'PRESELECTED': isPreselected,
        'TOUCHED': isTouched,
        'UNSELECTED': !isSelected
      }"
      selenium="select-pro-check-button"
      @click="$emit('toggleSelection')">

    <div class="d-flex" :class="{'SELECTED':isSelected, 'UNSELECTED': !isSelected }">
      <div class="m-b-1">
        <div class="PADDINGHEADER">
          <img v-if="isSelected" width="18"   src="../../../assets/CheckMark.svg"/>
          <img v-else width="18"   src="../../../assets/CheckBox.svg"/>
        </div>
        <div class="WHITECIRCLE">
          <vk-icon
              v-tooltip="{
                content: credentials.isInsured ?
                  `Insured for $${formatNumber(credentials.insuredAmount)}` :
                  '',
              }"
              :name="credentials.isInsured ? 'insured' : 'insured-inactive'"
              size="18"
              selenium="insured-button"
          />
        </div>
        <div class="WHITECIRCLE">
          <vk-icon
              v-tooltip="{
                content: credentials.isLicensed ?
                  `License number: ${credentials.licenseNumber}` :
                  '',
              }"
              :name="credentials.isLicensed ? 'certfied' : 'certfied-inactive'"
              size="18"
              selenium="licensed-button"
          />
        </div>

      </div>
      <div class="AVATAR-IMAGE">
        <pro-avatar :image="avatar" :size="60" selenium="pro-avatar-label"/>
        <img
            v-if="isTopPro"
            v-tooltip="{
              targetClasses: 'c-white',
              content: 'Verified top performance.',
            }"
            class="FIVE-STAR-BADGE"
            src="@/assets/TopPro.svg"
            height="15"
            width="15"
        >
        <img
            v-else-if="isFiveStar"
            v-tooltip="{
              targetClasses: 'c-white',
              content: 'Pros with a 5-star rating.',
            }"
            class="FIVE-STAR-BADGE"
            src="@/assets/FiveStarPro.svg"
            height="15"
            width="15"
            selenium="public-profile-five-stars-badge"
        >

      </div>
    </div>
  </div>
</template>

<script>
import formatNumber from '@/filters/format-number';
import Vector from '../../../assets/Padding.svg';

export default {
  name: 'pro-card-header',
  props: {
    publicProfileId: {
      type: Number,
      required: true,
    },
    avatar: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 85,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isPreselected: {
      type: Boolean,
      default: false,
    },
    isTouched: {
      type: Boolean,
      default: false,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    isTopPro: {
      type: Boolean,
      default: false,
    },
    isFiveStar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkboxImage () {
      return this.isSelected ? Vector : null;
    },
    credentials () {
      return this.$store.getters['jobrequest/matches/publicProfileCredentials'](this.publicProfileId);
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @mixin ProCard-selectButtonIconText($text) {
    @include absolute(auto, auto, 20px, 55px);
    @include text-medium();
    content: $text;
    font-weight: 400;
    color: $color-gray40;

    @include desktop {
      @include absolute(5px, 24px, auto, auto);
    }
  }

  @mixin ProCard-selectButtonIconTextModal($text) {
    @include ProCard-selectButtonIconText($text);
    @include absolute(auto, auto, 20px, 55px);
    @include desktop {
      @include absolute(65px, 15px, auto, auto);
    }
  }

  .PROCARD-HEADERNEW{
    height: 100%;
    width:60px;
   //background-color: #BFBFBF;
    .SELECTED{
    height: 100%;
    width: 60px;
    background-color: #F96302;
  }
  .UNSELECTED{
    height: 100%;
    width: 60px;
    background-color: #BFBFBF;
  }

  }

  .PROCARD-HEADER {
    height: 100%;
    width: 80px;
    position: relative;
    @include desktop {
      width: 100%;
      height: 100%;
    }

    &:before {
      @include absolute(0, auto, auto, 0);
      @include rect(50%, 100%);
      content: '';
      background: $color-gray60;

      @include desktop {
        @include absolute(0, auto, auto, 0);
        @include rect(50%, 100%);
      }
    }

    &.PRO-INFO-MODAL-HEADER {
      height: 190px;

      @include desktop {
        height: 100px;
      }

      &:before {
        @include desktop {
          @include absolute(100px, auto, auto, 0);
        }
      }
    }

    &:hover {
      .CHECK {
        color: white;
        background-color: $color-depot;
      }
    }
  }

  .UNSELECTED {
    .CHECK {
        color: $color-gray60;
    }
  }

  .SELECTED:before {
    background-color: #fea972;
  }

  .SELECTED {
    .CHECK {
      color: $color-depot;
      background-color: white;
      border-color: $color-depot;
    }

    &:hover {
      .CHECK {
        color: white;
        background-color: $color-gray60;
        border-color: $color-depot;
      }
    }
  }

  .AVATAR-IMAGE {
    position: absolute;
    margin-top: 15px;
    left: 28px
  }

  .PRO-INFO-MODAL-HEADER {
    .CHECK {
      @include absolute(auto, auto, 15px, 10px);

      @include desktop {
        @include absolute(95px, 25px, auto, auto);
      }
    }
    .AVATAR-IMAGE {
      @include square(80px);
      @include desktop {
       @include square(210px);
      }
    }

    &.PRESELECTED {
      &:not(.TOUCHED):after {
        @include ProCard-selectButtonIconTextModal('Preselected');
      }
    }

    &.SELECTED {
      &:hover:after {
        @include ProCard-selectButtonIconTextModal('Deselect');
      }
    }

    &.UNSELECTED {
      &:hover:after {
        @include ProCard-selectButtonIconTextModal('Select');
      }
    }
  }

  .CHECK {
    @include absolute(10%, 10%, auto, auto);
    @include square(30px);
    border: 2px solid $color-gray40;
    border-radius: 50%;
    text-align: center;
    background-color: white;
    z-index: 20;
    padding: 4px 0;

    @include desktop {
      @include absolute(10%, 10%, auto, auto);
    }
  }
  .FIVE-STAR-BADGE {
     position: absolute;
     bottom: 10%;
     left: 80%;
  }
  .SQUARECHECKBOX{
    width: 12px;
    height: 12px;
   border:1px solid white;
   display: flex;
   justify-content: center;
  }
  .IMAGECHECKBOX{
    width: 24px;
  }
  .WHITECIRCLE{
    width: 18px;
    height: 18px;
    border-radius: 9px;
    background-color: white;
    margin-top: 12px;
    margin-left: 5px;


  }
  .PADDINGHEADER{
    margin-left: 5px;
    margin-top: 5px;

  }
</style>
